import React, { Component } from 'react'
import { Modal, Button } from 'react-bootstrap'
import * as actions from '../actions'
import { connect } from 'react-redux'

class EstadoIngresoAnterior extends Component {
  componentWillUnmount () {
    this.props.updateShowCaladoConfirmacionAnulacion(true)
  }

  componentDidMount () {
    const { cea } = this.props
    if (!cea.ctg) {
      this.props.updateShowCaladoConfirmacionAnulacion(false)
    }
  }

  updateShowCaladoConfirmacionAnulacion () {
    this.props.updateShowCaladoConfirmacionAnulacion(false)
  }

  getAccionAdicional () {
    const {
      cea
    } = this.props

    let mensaje = cea.estadoCalificacion !== 'R'
      ? `Si realiza un nuevo analisis el anterior será anulado`
      : null
    if (cea.rechazoAdministrativoCalado === 'P') {
      mensaje = `La carga tiene autorización administrativa pendiente. ${mensaje} `
    } else if (cea.rechazoAdministrativoCalado === 'R') {
      mensaje = `La carga se rechazó administrativamente. ${mensaje}`
    }
    return mensaje
  }

  getCalificacion () {
    const { cea } = this.props
    let calificacion = null

    switch (cea.estadoCalificacion) {
      case 'R':
        calificacion = 'rechazado'
        break
      case 'A':
        calificacion = 'conforme'
        break
      case 'C':
        calificacion = 'condicional'
        break
      default:
        calificacion = null
    }
    return calificacion
  }

  renderLeyendaIngreso () {
    const { cea, cpa } = this.props

    if (cea.rechazoEnPesado) {
      return (<div>
        El camión fue rechazado en pesado. Se creará otro análisis de calado
      </div>)
    } else if (cea && cpa.esatdoCtg !== 'R') {
      return (<div>
        Carta de Porte Rechazada y Redireccionada en Afip. Se creará un nuevo análisis de calado
      </div>)
    }

    const calificacion = this.getCalificacion()
    const acccionAdicional = this.getAccionAdicional()

    return (
      <><p>Ya se ha procesado este camión como <strong>{calificacion}</strong>.</p><p>{acccionAdicional}</p></>
    )
  }

  render () {
    const {
      show,
      onPrev
    } = this.props

    return (
      <Modal className='estado-ingreso-anterior' show={show} onHide={() => null}>
        <Modal.Body style={{ backgroundColor: '#ffffff' }}>
          <h5 style={{ marginBottom: '1.2rem' }}>Estado ingreso anterior</h5>
          <div style={{ fontSize: '16px' }} id='modal-estado-anterior'>
            {this.renderLeyendaIngreso()}
          </div>
        </Modal.Body>
        <Modal.Footer style={{ backgroundColor: '#ffffff' }}>
          <Button
            onClick={() => onPrev()}
          >Cancelar</Button>
          <Button
            onClick={() => this.updateShowCaladoConfirmacionAnulacion()}
          >Confirmar</Button>
        </Modal.Footer>
      </Modal>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    show: state.calado.showCaladoConfirmacionAnulacion,
    cea: state.calado.consultaCea || {}
  }
}

const withRedux = connect(mapStateToProps, actions)
export default withRedux(EstadoIngresoAnterior)
